import classNames from "classnames";
import Icons from "react-icons/fi";

import LoadingIndicator from "../LoadingIndicator";
import SvgIcon from "../SvgIcon";

import styles from "./index.module.scss";

interface IButtonProps {
  id?: string;
  label: string;
  type?: "button" | "submit" | "reset";
  icon?: keyof typeof Icons;
  variant?: "primary" | "secondary" | "dark" | "link";
  size?: "sm" | "md" | "lg";
  onClick?: () => void | Promise<void>;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

function Button({
  id,
  label,
  type = "button",
  icon,
  variant = "primary",
  size = "lg",
  onClick,
  loading = false,
  disabled = false,
  className = "",
}: IButtonProps) {
  return (
    <button
      id={id}
      type={type}
      disabled={loading || disabled}
      onClick={onClick}
      className={classNames(
        styles.button,
        styles[`button_${variant}`],
        styles[`button_size_${size}`],
        className,
        { [styles.button_withIcon]: icon },
      )}>
      {loading ? <LoadingIndicator width={30} height={30} /> : label}

      {icon && <SvgIcon type={icon} />}
    </button>
  );
}

export default Button;
